import gql from 'graphql-tag';

export const GET_SALESPERSON_NAME = gql`
	query GetSalespersonName($id: String!) {
		user(id: $id) {
			id
			name
			email
			phoneNumber
		}
	}
`;

export const GET_INVITE_CODES = gql`
	query GetInviteCodeForSalesperson($q: JSON!, $limit: Int, $offset: Int) {
		forms(query: $q, limit: $limit, offset: $offset) {
			id
			isActive
			formType
			formData
			salesman {
				id
				name
				image
			}
			inviteCode
		}
	}
`;
